import "@fontsource/noto-sans-jp";
import "./src/styles/base.css";
import "./src/styles/blog-contents-style.css";

export const onRouteUpdate = () => {
  if (typeof document === "undefined") return;

  /* ------------------------------
   * fadeInUp
   * ------------------------------ */
  const elements = document.querySelectorAll(".fadeInUp");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("on");
        }
      });
    },
    { threshold: 0.1 }
  );

  elements.forEach((el) => observer.observe(el));

  /* ------------------------------
   * Q&A アコーディオン
   * ------------------------------ */
  const qaItems = document.querySelectorAll(
    ".recruitPage .faqSec .qa-list dl"
  );

  qaItems.forEach((dl) => {
    if (dl.dataset.bind) return;
    dl.dataset.bind = "true";

    const dt = dl.querySelector("dt");
    const dd = dl.querySelector("dd");
    if (!dt || !dd) return;

    dt.addEventListener("click", () => {

      qaItems.forEach((item) => {
        const itemDd = item.querySelector("dd");

        if (item !== dl) {
          item.classList.remove("open");
          if (itemDd) itemDd.style.maxHeight = null;
        }
      });

      if (dl.classList.contains("open")) {
        dl.classList.remove("open");
        dd.style.maxHeight = null;
      } else {
        dl.classList.add("open");
        dd.style.maxHeight = dd.scrollHeight + "px";
      }

    });
  });
};

export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js");
  }
};